/**
 * 仅用于前端判断会话是否仍有效（不替代服务端验签）。
 * 当 localStorage 未写入 token_expire_time 时，用 JWT 内 exp 避免误判过期、反复清存储与换票写库。
 */

function base64UrlToJson(payload: string): Record<string, unknown> | null {
  try {
    const b64 = payload.replace(/-/g, '+').replace(/_/g, '/')
    const pad = b64.length % 4 === 0 ? '' : '='.repeat(4 - (b64.length % 4))
    const json = atob(b64 + pad)
    return JSON.parse(json) as Record<string, unknown>
  } catch {
    return null
  }
}

export function getJwtExpiryMs(token: string): number | null {
  try {
    const parts = token.split('.')
    if (parts.length < 2) return null
    const payload = base64UrlToJson(parts[1])
    const exp = payload?.exp
    if (typeof exp !== 'number') return null
    return exp * 1000
  } catch {
    return null
  }
}

/** skewMs：提前 skew 视为过期，避免边界请求失败 */
export function isJwtNotExpired(token: string, skewMs = 60_000): boolean {
  const ms = getJwtExpiryMs(token)
  if (ms == null) return false
  return ms > Date.now() + skewMs
}

export function jwtExpiryToIsoString(token: string): string | null {
  const ms = getJwtExpiryMs(token)
  if (ms == null) return null
  return new Date(ms).toISOString()
}
